/**
 * 模組頁面代碼 : 1210-UI-02
 * 頁面說明 : 電梯資料新增修改視窗
 * @module web/modules/elevator/components/ElevatorModal
 */

// ----- import from npm modules -----
import React, { useState, useEffect, useRef } from 'react';

// ----- import from local modules -----

// ----- constants -----
const ELEVATOR_NEW = 'new';
const ELEVATOR_EDIT = 'edit';

const RESPONSE_OK = 200;
const TITLE_ELEVATOR_NEW = '新增電梯資料';
const TITLE_ELEVATOR_EDIT = '修改電梯資料';
const ICON_ELEVATOR_NEW = '#ico-plus';
const ICON_ELEVATOR_EDIT = '#ico-edit';

const ElevatorModal = React.forwardRef((props, ref) => {
    const { mode, elevator, buildingSelection, searchElevator } = props;

    let modalIcon = mode === ELEVATOR_NEW? ICON_ELEVATOR_NEW : ICON_ELEVATOR_EDIT;
    let modalTitleText = mode === ELEVATOR_NEW? TITLE_ELEVATOR_NEW : TITLE_ELEVATOR_EDIT;

    // 初始化state
    const [formValues, setFormValues] = useState({
        modalElevatorBuilding: '',
        modalElevatorName: '',
        modalElevatorNum: '',
        modalControlDeviceName: '',
    });

    const[deviceList, setDeviceList] = useState([]);
    const [invalidShow, setInvalidShow] = useState('none');

    // 更新梯控裝置選項
    const updateDeviceList = (buildingId) => {
        const building = buildingSelection.find(building => building.buildingId === buildingId);
        setDeviceList(building?.devices || []);
    };

    // Handle change event
    const handleChange = (event) => {
        const target = event.target;
        let value = target.value;

        if (target.name === 'modalElevatorBuilding') {
            const buildingId = parseInt(value);
            updateDeviceList(buildingId);
        }

        setFormValues({
            ...formValues,
            [target.name]: target.type === 'checkbox' ? target.checked : value,
        });
    };

    // 使用useEffect在elevator改變才更新formValues
    useEffect(() => {
        setFormValues({
            modalElevatorBuilding: elevator? elevator.buildingId: '',
            modalElevatorName: elevator? elevator.elevatorName : '',
            modalElevatorNum: elevator? elevator.elevatorNum : '',
            modalControlDeviceName: elevator? elevator.deviceId : '',
        });

        if (elevator!==null) {
            updateDeviceList(elevator.buildingId);
        } else {
            setDeviceList([]);
         }

        setInvalidShow('none');
    }, [elevator]);

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        // 檢查表單是否驗證通過
        if (form.checkValidity() === false) {
            setInvalidShow('block');
            form.classList.add('was-validated');
            return;
        }

        // 建立 FormData 讀取表单的值
        const formData = new FormData(form);

        // 建立 elevator 物件
        const saveElevator = {
            elevatorId: mode === ELEVATOR_NEW? null : elevator.elevatorId,
            buildingId: parseInt(formData.get('modalElevatorBuilding')),
            elevatorName: formData.get('modalElevatorName'),
            elevatorNum: formData.get('modalElevatorNum'),
            deviceId: parseInt(formData.get('modalControlDeviceName')),
        };

        // 呼叫父層元件的新增或修改大樓資料函式
        if (mode === ELEVATOR_NEW) {
            // 调用 props.addElevator 方法
            props.addElevator(saveElevator).then((response) => {
                const statusCode = response.payload.code;
                if (statusCode !== RESPONSE_OK) {
                    $(ref.current).modal('hide');
                    props.onErrorHandle(TITLE_ELEVATOR_NEW, response.payload );
                } else {
                    // 调用 fetchElevatorList and Hide the modal
                    const { buildingId, elevatorName, elevatorId } = searchElevator;
                    props.fetchElevatorList(buildingId, elevatorName, elevatorId).then(() => {
                        props.setNeedElevatorLoad(true);
                        $(ref.current).modal('hide');
                    });
                }
            });
        } else if (mode === ELEVATOR_EDIT) {
            // 调用 props.editElevator 方法
            props.editElevator(saveElevator).then((response) => {
                const statusCode = response.payload.code;
                if (statusCode !== RESPONSE_OK) {
                    $(ref.current).modal('hide');
                    props.onErrorHandle(TITLE_ELEVATOR_EDIT, response.payload );
                } else {
                    // 调用 fetchElevatorList and Hide the modal
                    const { buildingId, elevatorName, elevatorId } = searchElevator;
                    props.fetchElevatorList(buildingId, elevatorName, elevatorId).then(() => {
                        props.setNeedElevatorLoad(true);
                        $(ref.current).modal('hide');
                    });
                }
            });
        }
    };

    return (
        <div ref={ref}
            className="modal fade"
            id="modalElevator"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="modalElevatorLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <form className="modal__form modal-content needs-validation" id="modalElevatorForm" onSubmit={handleSubmit}>
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="modalElevatorLabel">
                            <div className="modal__title__badge">
                                <svg className="badge__icon" aria-hidden="true">
                                    <use href={modalIcon}></use>
                                </svg>
                            </div>
                            <div className="modal__title__text">{modalTitleText}</div>
                        </h1>
                        <button type="button" className="btn-close btn-cancel" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex flex-column gap-3 px-2">
                            <div className="modal__form__catagory row">
                                <div className="col-3">
                                    <div className="modal__form__catagory__lable">大樓</div>
                                </div>
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col">
                                            <label htmlFor="modalElevatorBuilding" className="form-label">大樓名稱*</label>
                                            <select
                                                className="form-select form-select-sm"
                                                id="modalElevatorBuilding"
                                                name="modalElevatorBuilding"
                                                value={formValues.modalElevatorBuilding || ""}
                                                onChange={handleChange}
                                                required>
                                                    <option disabled value="">請選擇</option>
                                                    {buildingSelection.map((building, index) => (
                                                        <option key={index} value={building.buildingId}>{building.buildingName}</option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal__form__catagory row">
                                <div className="col-3">
                                    <div className="modal__form__catagory__lable">電梯</div>
                                </div>
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col-6">
                                            <label htmlFor="modalElevatorName" className="form-label">電梯名稱*</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="modalElevatorName"
                                                name="modalElevatorName"
                                                value={formValues.modalElevatorName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label htmlFor="modalElevatorNum" className="form-label">電梯編號*</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="modalElevatorNum"
                                                name="modalElevatorNum"
                                                value={formValues.modalElevatorNum}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal__form__catagory row">
                                <div className="col-3">
                                    <div className="modal__form__catagory__lable">梯控裝置</div>
                                </div>
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col">
                                            <label htmlFor="modalControlDeviceName" className="form-label">梯控裝置名稱*</label>
                                            <select
                                                className="form-select form-select-sm"
                                                id="modalControlDeviceName"
                                                name="modalControlDeviceName"
                                                value={formValues.modalControlDeviceName || ""}
                                                onChange={handleChange}
                                                required>
                                                    <option disabled value="">請選擇</option>
                                                    {deviceList && deviceList.map((device, index) => (
                                                        <option key={index} value={device.deviceId}>{device.deviceName}({device.deviceHost})</option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-warning global-invalid-feedback" style={{ display: invalidShow }}></div>
                                </div>
                            </div>
                            <input type="hidden" id="modalElevatorEditTime" name="修改時間" value="..." />
                            <input type="hidden" id="modalElevatorEnable" name="啟用" value="1" />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">取消</button>
                        <button type="submit" className="btn btn-primary">儲存</button>
                    </div>
                </form>
            </div>
        </div>
    );
});

export default ElevatorModal;